<template>
  <!-- 批量操作 -->
  <div>
    <Modal v-model="visible" title="批量打款" :mask-closable="false" width="500px" class="my-modal">
      <loading :isShow="loading" />
      <div class="confirm-box">
        <div style="margin-bottom: 20px">请确认下方数据</div>
        <!-- <div style="margin-bottom: 20px">已选择{{ detail.checkCount }}条申请中/待打款的记录</div> -->
        <!-- <div style="margin-bottom: 20px">结算主体：{{ detail.settlementEntity }}</div> -->
        <div>
          <span>合计打款业务员人数：{{ detail.userCount }}人</span>
          <span style="margin-left: 20px">金额：{{ detail.requestAmount }}元</span>
        </div>
        <!-- <div style="margin-top: 20px;margin-bottom: 10px">备注：</div>
        <Input type="textarea" v-model="detail.remark" placeholder="请输入" /> -->
      </div>
      <div slot="footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Tooltip v-if="detail.checkCount > 10" placement="top" :content="btnText + '一次性不能超过十条！'">
          <Button :disabled="true" type="primary" style="marigin-left: 10px">{{ btnText }}</Button>
        </Tooltip>
        <Button v-else type="primary" @click="submit">{{ btnText }}</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- ok保提现验证 -->
    <update-invoice ref="updateInvoiceRef" @reload="reload" />
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import { common } from '@/api/mixins';
import updateInvoice from './updateInvoice';

export default {
  mixins: [common],
  components: {
    confirmModal,
    updateInvoice
  },
  data() {
    return {
      btnText: '打款',
      tabId: '',
      visible: false,
      params: {},
      detail: {},
      loading: false
    };
  },
  computed: {},
  methods: {
    open(params, tabId) {
      this.params = {
        ...params,
        operationType: 1
      };
      this.tabId = tabId;
      let url = '';
      if (tabId == 1) {
        // 结算单发放
        url = '/buz/userCashWithdrawLog/okbRiskBatchDetail';
      } else if (tabId == 2) {
        // 风险单发放
        url = '/buz/userCashWithdrawLog/okbRiskPolicyBatchDetail';
      }
      this.$http({
        url: url,
        type: 'POST',
        data: params
      }).then(res => {
        if (res.data) {
          this.detail = res.data;
          this.visible = true;
        }
      });
    },
    submit() {
      console.log(this.params);
      let params = JSON.parse(JSON.stringify(this.params));
      if (this.tabId == 1) {
        params.policyNo = this.detail.reportNames.join(', ');
      } else if (this.tabId == 2) {
        params.policyNo = this.detail.policyNos.join(', ');
      }
      params.commissionPrice = this.detail.requestAmount;
      this.$refs.updateInvoiceRef.open(params, this.tabId);
    },
    // 操作完成刷新
    reload() {
      this.$emit('reload');
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
